let language = {
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_COUPON_CODE: "优惠码:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_TAX: "税费:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_IMPORT_SERVICE_FEE: "进口服务费:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_SHIPPING: "运费:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_PRODUCTS: "产品:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_DISCOUNT: "折扣:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_TOTAL_DUE: "应付总额:",
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_PAYMENT_METHOD: "支付方式:",
    
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_REDEEM_BTN: "兑换",
    
    BULK_ORDER_CHECKOUT_STEP_PAYMENT_USED_TIPS: "优惠券已成功申请。"
};

export { language }
